import { FunctionComponent } from "react";
import "./Checkbox.scss";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const Checkbox: FunctionComponent<IProps> = (props) => {
  return (
    <label className={"checkbox " + props.className}>
      <input
        className="checkbox__input"
        name={props.name}
        value={props.value}
        type="checkbox"
        onChange={props.onChange}
        checked={props.checked}
        disabled={props.disabled}
      />
      <span className="checkbox__indicator"></span>
      <span className={"checkbox__text" + (props.disabled ? " disabled" : "")}>{props.label}</span>
    </label>
  );
};

export default Checkbox;
